function initExternalContent() {
    initExternalContentForType('twitter');
    initExternalContentForType('vimeo');
    initExternalContentForType('linkedin');
    initExternalContentForType('youtube');

    $('.external-content-show-always').click(function() {
        var type = $(this).data('external-content');
        setCookie(getCookieName(type), 1, 364);
        loadExternalContent(type);
        $('.external-content-placeholder-' + type).hide();
    });

    $('.external-content-show-once').click(function() {
        // only show the content that was clicked on
        var $parent = $(this).closest('.frame-type-mask_ce_external_content');
        $parent.find('.external-content').each(function() {
            $(this).html($(this).html().replace(/data-src=/g,'src='));
            $(this).show();
        });
        $parent.find('.external-content-placeholder').hide();
    });
}

function getCookieName(type) {
    return 'externalContentConsent_' + type;
}

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() + ";SameSite=Lax";
}

function loadExternalContent(type) {
    $('.external-content-' + type).each(function () {
        $(this).html($(this).html().replace(/data-src=/g,'src='));
        $(this).show();
    });
}

function initExternalContentForType(type) {
    var cookie = getCookie(getCookieName(type));
    if (cookie !== null && cookie.length > 0){
        loadExternalContent(type);
    } else {
        $('.external-content-placeholder-' + type).show();
    }
}